import styled from "styled-components";

export const CardWrapper = styled.div`
	position: relative;
	border-radius: 15px;
	background: var(--Secondary-Colour-New1, linear-gradient(180deg, #392750 0%, #25153c 100%));
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	display: flex;
	width: 300px;
	min-height: 112px;
	align-items: center;
	gap: 15px;
	flex-shrink: 0;
	margin-bottom: 10px;
	height: 112px;
	@media (min-width: 375px) {
		width: 350px;
		min-height: 140px;
		height: 140px;
	}
	:hover,
	:focus {
		#play-overlay {
			padding: 0 8px;
			display: flex;
			top: 0;
		}
	}
`;

export const ImageWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		width: 136px;
		height: 112px;
		border-radius: 15px;
		box-shadow:
			0px 0px 20px 0px rgba(0, 0, 0, 0.25) inset,
			0px 4px 4px 0px rgba(0, 0, 0, 0.25);
		border-radius: 15px;
		@media (min-width: 375px) {
			width: 170px;
			min-height: 140px;
		}
	}
	img[data-size="small"] {
		width: 136px;
		height: 106px;
		padding-left: 5px;

		@media (min-width: 1600px) {
			width: 170px;
			height: 140px;
		}
	}

	img[data-size="medium"] {
		width: 136px;
		height: 252px;
		padding-left: 5px;

		@media (min-width: 1600px) {
			width: 170px;
			height: 320px;
		}
	}

	img[data-size="large"] {
		width: 282px;
		height: 252px;
		padding-left: 5px;

		@media (min-width: 1600px) {
			width: 350px;
			height: 320px;
		}
	}
`;

export const GameAffiliateName = styled.span`
	text-transform: uppercase;
	color: var(--secondary-text-color);
	font-size: 9px;
	line-height: 11px;
	letter-spacing: 0.25px;
	max-width: 110px;
	padding-top: 10px;
	padding-bottom: 5px;

	@media (min-width: 375px) {
		max-width: 130px;
		font-size: 10px;
		line-height: 12px;
	}
`;

export const GameName = styled.span`
	font-size: 12px;
	text-transform: uppercase;
	color: var(--gray-white, #fff);
	font-weight: 600;
	line-height: 14px;
	letter-spacing: 0.75px;
	max-width: 140px;

	@media (min-width: 375px) {
		font-size: 14px;
		line-height: 16px;
	}
`;

export const PlayNowButton = styled.button`
	display: flex;
	width: 110px;
	height: 30px;
	justify-content: center;
	align-items: center;
	gap: 5px;
	border-radius: 20px;
	color: var(--Gray-00, #fff);
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
	margin: 10px 0;
	border: none;
	cursor: pointer;
	background: var(--main-gradient);

	@media (min-width: 375px) {
		width: 140px;
		height: 40px;
	}
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	height: 100%;
	width: 100%;

	.fav-icon {
		align-self: flex-end;
		margin: 10px;
		cursor: pointer;
		position: absolute;
		top: 0;
		right: 0;
	}
`;
